module.exports = __webpack_public_path__ + "static/media/connecttofitlogo.b297a071.svg";